export default __webpack_public_path__ + "static/media/img_07.0cb2e5ee.jpg";